import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        activeTabTDA: localStorage.getItem('activeTabTDA') || 'TDA-G10',
        activeTabCACA: localStorage.getItem('activeTabCACA') || 'CACA-Pre',
    },
    getters: {
        getActiveTab(state) {
            return (key) => {
                return state['activeTab' + key];
            }
        }
    },
    mutations: {
        setActiveTab(state, data) {
            state['activeTab' + data.key] = data.tab;
            localStorage.setItem('activeTab' + data.key, data.tab);
        }
    },
    actions: {},
    modules: {}
})
